import React, { useContext } from 'react'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import './About.sass'
import Button from '../../ui/Button/Button'
import bgImage from './aboutImg.jpg'
import { AuthContext } from '../../App'
import Icon from '../../ui/Icon/Icon'
import ServicePrice from '../ServicePrice/ServicePrice'

function About() {
  const { contacts, setShowContactUs } = useContext(AuthContext)

  const benefits = [
    {
      title: 'Опытные специалисты',
      description: `Наша команда работает более 5 лет и обладает необходимым опытом для выполнения сложных задач`,
      icon: 'users',
    },
    {
      title: 'Современное оборудование',
      description:
        'У нас есть множество современных инструментов для реализации работ по установленным технологиям',
      icon: 'toolbox',
    },
    {
      title: 'Гарантия качества',
      description: 'Вся работа будет выполнена качественно и в срок',
      icon: 'shield-check',
    },
    {
      title: 'Доступные цены',
      description:
        'Адекватное соотношение цены и качества. Доступность оплаты любым способом.',
      icon: 'wallet',
    },
  ]
  return (
    <section id="about" name="about" class="About">
      <div className="DefaultContainer">
        <SectionTitle title="Услуги" />
        <div class="About-Container">
          <div class="About-Text">
            <p>
              Наша компания предлагает услуги по профессиональному покосу травы,
              стрижке кустарников, спилу деревьев на любых территориях в
              Воронеже и ВО. Мы используем современное оборудование и следим за
              качеством работы на каждом этапе. Среди наших преимуществ:
            </p>
            <div className="Benefits-Container">
              {benefits.map((b) => (
                <div className="BenefitTile">
                  <Icon name={b.icon} weight="regular" />
                  <div className="Text">
                    <p className="Title">{b.title}</p>
                    <p className="Description">{b.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <p>
              Мы работаем быстро и аккуратно, учитывая все особенности
              территории клиента. Обращаясь к нам, вы можете быть уверены, что
              ваш участок будет выглядеть ухоженно и аккуратно.
              <br />
              <br />
              Свяжитесь с нами, чтобы узнать больше о наших услугах и заказать
              покос травы.
            </p>

            {/* <Button
              title="Заказать звонок"
              type="button"
              icon="phone"
              iconWeight="solid"
              onClick={() =>
                setShowContactUs({
                  show: true,
                  title: 'Заказать',
                  emailSubject: 'Запит на консультацію',
                })
              }
              // onClick={() => (window.location.href = `tel:${contacts.phone}`)}
            /> */}
          </div>
          <div className="AboutImg">
            <img src={bgImage} alt="Косим травку" />
          </div>
          <ServicePrice />
        </div>
      </div>
    </section>
  )
}

export default About
